module.exports = __webpack_public_path__ + "static/media/onboard-5-grid.36ae58d6.gif";